// src/com/auto_plan/AutoPlanGql.js
import { gql } from "@apollo/client";

/*

extend type Mutation {
	autoPlanBuild(autoPlan: InputAutoPlanBuild!): CommonResponse!
	autoPlanSave(autoPlan: InputAutoPlanSave!): CommonResponse!
	autoPlanRemove(autoPlan: InputAutoPlanRemove!): CommonResponse!
}

input InputAutoPlanBuild {
	planDate: String!
}

*/

export const BUILD_AUTO_PLAN = gql`
mutation BuildAutoPlan($autoPlan: InputAutoPlanBuild!) {
    autoPlanBuild(autoPlan: $autoPlan) {
        ok
        message
    }
}
`;

/*

input InputAutoPlanSave {
    arriveId: String!
    dcCd: String!
    planDate: String!
    hocha: Int!
    storeId: String
    storeApplyCom: String
    vehTypeId: String
    nextDay: Boolean
    shprTime: String
    startTime: String
    arriveTime: String
    returnTime: String
    note: String
}

input InputAutoPlanRemove {
    arriveId: String!
    dcCd: String!
    planDate: String!
    hocha: Int!
}

*/
export const SAVE_AUTO_PLAN = gql`
mutation SaveAutoPlan($autoPlan: InputAutoPlanSave!) {
    autoPlanSave(autoPlan: $autoPlan) {
        ok
        message
    }
}
`;

export const REMOVE_AUTO_PLAN = gql`
mutation RemoveAutoPlan($autoPlan: InputAutoPlanRemove!) {
    autoPlanRemove(autoPlan: $autoPlan) {
        ok
        message
    }
}
`;
